import styled from 'react-emotion'

export const Container = styled.div`
  overflow: hidden;
`

export const Content = styled.main`
  position: relative;
`
